import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProof() {
  return <section className="py-12 border-y border-white/5 bg-slate-900/30" data-id="element-233">
      <div className="container mx-auto px-4" data-id="element-234">
        <div className="flex flex-wrap justify-center gap-8 md:gap-16 mb-12 text-center" data-id="element-235">
          <Stat value="+1.000" label="personas ya duermen mejor" data-id="element-236" />
          <Stat value="6" label="Tomos listos" data-id="element-237" />
          <Stat value="6" label="Bonos incluidos" data-id="element-238" />
          <Stat value="4.9/5" label="⭐" data-id="element-239" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-240">
          <TestimonialMini initials="JM" quote="Dormí 8 horas seguidas por primera vez en dos años. El Tomo 3 del entorno cambió todo." author="Julián M., Buenos Aires" data-id="element-241" />
          <TestimonialMini initials="CR" quote="Siempre pensé que era ansioso. En realidad tenía el cuarto mal configurado y cenaba a las 22:00. Resuelto." author="Carolina R., Rosario" data-id="element-242" />
          <TestimonialMini initials="MA" quote="Me despertaba a las 3 AM todas las noches. El Bono 6 me dio el protocolo exacto. Ya no pasa." author="Marcos A., Córdoba" data-id="element-243" />
        </div>
      </div>
    </section>;
}
function Stat({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-244">
      <span className="text-3xl font-display font-bold text-white mb-1" data-id="element-245">
        {value}
      </span>
      <span className="text-sm text-slate-400 font-medium" data-id="element-246">{label}</span>
    </div>;
}
function TestimonialMini({
  initials,
  quote,
  author
}: {
  initials: string;
  quote: string;
  author: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="p-6 rounded-2xl bg-slate-800/40 border border-white/5 flex flex-col h-full" data-id="element-247">
      <div className="flex items-center gap-3 mb-4" data-id="element-248">
        <div className="w-10 h-10 rounded-full bg-amber-500/20 text-amber-500 flex items-center justify-center font-bold text-sm border border-amber-500/30" data-id="element-249">
          {initials}
        </div>
        <div className="flex text-amber-400" data-id="element-250">
          {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" data-id="element-251" />)}
        </div>
      </div>
      <p className="text-slate-300 text-sm leading-relaxed mb-4 flex-grow italic" data-id="element-252">
        "{quote}"
      </p>
      <p className="text-xs text-slate-500 font-medium" data-id="element-253">— {author}</p>
    </motion.div>;
}